import { render, staticRenderFns } from "./OgTableHead.vue?vue&type=template&id=5a27ff68&"
import script from "./OgTableHead.vue?vue&type=script&lang=js&"
export * from "./OgTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports